import { useEffect, useState } from "react";
import BasicWrapper from "../../components/basicWrapper/basicWrapper";
import ExtendedWrapper from "../../components/extendedWrapper/extendedWrapper";
import { IvnoiceContextProvider } from "../createInvoice/createInvoiceContext";

import "../createInvoice/steps/createInvoice.css"
//
import CalculateInvoiceWrapperExtended from "./calculateInvoiceWrapperExtended";
import StepsHeader from "./steps/utils/stepsHeader";

export default function CalculateInvoiceWrapper() {
    const [invoiceStep, setInvoiceStep] = useState(0);
    const [maxStep, setMaxStep] = useState(1);

    // Update max step by 1 when reaching current max step
    useEffect(() => {
        if (maxStep === 4) return;
        if (invoiceStep >= maxStep) setMaxStep(maxStep + 1);
    }, [invoiceStep]);

    return (
        <>
        <StepsHeader step={invoiceStep} setInvoiceStep={setInvoiceStep} maxStep={maxStep} />
        <BasicWrapper>
            <IvnoiceContextProvider>
                <CalculateInvoiceWrapperExtended
                    invoiceStep={invoiceStep} setInvoiceStep={setInvoiceStep}
                    maxStep={maxStep} />
            </IvnoiceContextProvider>
        </BasicWrapper>
        </>
    )
}